import React, { useState, useRef } from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import "../style/ShortenedItem.scss";

function ShortenedItem({ original, short, id, deleteLink }) {
  const [isCopied, setIsCopied] = useState(false);
  const itemRef = useRef(null);

  const copyText = () => {
    navigator.clipboard.writeText(short);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1100);
  };

  const animatedDeleteLink = () => {
    itemRef.current.classList.add("animated-delete");
    setTimeout(() => {
      deleteLink(id);
    }, 800);
  };

  return (
    <div className="shortened-item" ref={itemRef}>
      <div className="original-link">
        <p>{original}</p>
      </div>
      <div className="shortened-link">
        <p>{short}</p>
        <div className="buttons">
          <button className="delete-btn" onClick={animatedDeleteLink}>
            <FaRegTrashAlt />
          </button>

          <button
            className={`btn btn-primary copy-btn ${
              isCopied ? "copied-btn" : ""
            }`}
            onClick={copyText}
          >
            {isCopied ? "Copied!" : "Copy"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShortenedItem;
